// Libs
import log from 'loglevel';

/**
 * Ask permissions for local notifications if needed
 */
export const initLocalNotifications = (): void => {
  if (!('Notification' in window)) {
    return log.info('This browser does not support desktop notification');
  }

  // Otherwise, we need to ask the user for permission
  else if (Notification.permission !== 'granted' && Notification.permission !== 'denied') {
    Notification.requestPermission().then((permission) => {
      return log.info('Desktop notifications permission updated : ', permission);
    });
  }
};

/**
 * Show notification
 */
export const showLocalNotification = (title: string): void => {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;

  new Notification(title, {
    icon: `${process.env.NEXT_PUBLIC_APP_URL}/icons/apple-touch-icon.png`,
    requireInteraction: true,
  });
};
